import React from 'react';
import './Title.scss';

const Title = ({ title }) => <h2 className="mainHeading">{title}</h2>

export default Title
